import { FOCO_VISIVEL } from 'utils/foco';

import { ModoDaImagem } from '../selos-modelo';

const OPCOES: { modo: ModoDaImagem; rotulo: string }[] = [
  { modo: 'com-foto', rotulo: 'Com sua foto' },
  { modo: 'so-o-selo', rotulo: 'Só o selo' },
];

// Trilho do Meu Perfil v2: fundo surface-200 sem borda, opções de 11px. SPEC_DEVIATION: a opção inativa em
// azul-escuro, e não no azul do design. Reason: azul sobre o surface-200 fica em 4,15:1, abaixo de 4,5:1 (WCAG 1.4.3).
const OPCAO = `cursor-pointer rounded-jj-pill border-0 px-3.5 py-1.5 font-display text-[11px] font-bold uppercase tracking-[0.04em] ${FOCO_VISIVEL}`;
const OPCAO_ATIVA = `${OPCAO} bg-brand-blue text-brand-white`;
const OPCAO_INATIVA = `${OPCAO} bg-transparent text-brand-blue-dark`;

interface ModoDaMolduraProps {
  modo: ModoDaImagem;
  onModo: (modo: ModoDaImagem) => void;
}

/** Alternância "Com sua foto" / "Só o selo" dos cartões de selo (AJ2-21). */
export default function ModoDaMoldura({ modo, onModo }: ModoDaMolduraProps) {
  return (
    <div
      role="group"
      aria-label="Imagem dos selos"
      className="inline-flex items-center gap-1 rounded-jj-pill bg-surface-200 p-[3px]"
    >
      {OPCOES.map(opcao => (
        <button
          key={opcao.modo}
          type="button"
          aria-pressed={modo === opcao.modo}
          onClick={() => onModo(opcao.modo)}
          className={modo === opcao.modo ? OPCAO_ATIVA : OPCAO_INATIVA}
        >
          {opcao.rotulo}
        </button>
      ))}
    </div>
  );
}
